export { default } from "./settings-default-home.native";
